/**
 * Global QueryClient Instance
 *
 * Created OUTSIDE React so it can be used:
 * 1. In React components (via useQuery hooks)
 * 2. In React Router loaders (via routerQueryFetcher)
 *
 * Both share the same cache!
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 5 * 60 * 1000, // 5 minutes - data considered fresh
			gcTime: 10 * 60 * 1000, // 10 minutes - cache garbage collection
			refetchOnWindowFocus: false,
			retry: 1,
		},
	},
});

